import actions from "./moduleNoteActions.js";
export default {
  namespaced: true,
  actions: actions,
};
